export const categoryZones = [
  {
    id: 'zone-celebrity',
    name: '明星八卦',
    en: 'CELEBRITY',
    accent: 'primary',
    icon: 'ri-star-line',
    desc: '行程同框、合作绯闻、街拍路透，按时间线逐条整理。',
    stat: '今日 42 条',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20stage%20spotlight%20beams%20and%20velvet%20rope%20on%20deep%20crimson%20amber%20background%2C%20editorial%20collage%20texture%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20people&width=720&height=520&seq=hl-cat-01&orientation=landscape',
    items: [
      { title: '深夜聚餐同框路透，时间线已更新', meta: '12 分钟前' },
      { title: '品牌活动座位线索被多方解读', meta: '46 分钟前' },
      { title: '新剧杀青现场照片流出引讨论', meta: '1 小时前' },
    ],
  },
  {
    id: 'zone-entertainment',
    name: '娱乐瓜',
    en: 'SHOWBIZ',
    accent: 'secondary',
    icon: 'ri-fire-line',
    desc: '综艺幕后、片场花絮、节目冲突，视频与图文同步归档。',
    stat: '今日 57 条',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20clapperboard%20and%20popcorn%20scatter%20on%20warm%20amber%20crimson%20background%2C%20editorial%20collage%20texture%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20people&width=720&height=520&seq=hl-cat-02&orientation=landscape',
    items: [
      { title: '综艺未播片段外泄，剪辑争议升温', meta: '8 分钟前' },
      { title: '片场花絮整理完毕，时长约 4 分钟', meta: '38 分钟前' },
      { title: '节目组就票数问题二次发布说明', meta: '2 小时前' },
    ],
  },
  {
    id: 'zone-influencer',
    name: '网红历史',
    en: 'ARCHIVE',
    accent: 'primary',
    icon: 'ri-history-line',
    desc: '直播翻车、人设考古、账号风云，按年份梳理关键节点。',
    stat: '今日 31 条',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20glowing%20screen%20and%20archive%20cards%20on%20warm%20crimson%20amber%20background%2C%20editorial%20collage%20texture%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20people&width=720&height=520&seq=hl-cat-03&orientation=landscape',
    items: [
      { title: '旧直播切片被翻出，语境引发两派争论', meta: '21 分钟前' },
      { title: '账号改名时间线整理完成并公开', meta: '1 小时前' },
      { title: '早期合作记录补充可考来源', meta: '3 小时前' },
    ],
  },
  {
    id: 'zone-citizen',
    name: '素人爆料',
    en: 'TIP-OFF',
    accent: 'accent',
    icon: 'ri-user-voice-line',
    desc: '素人投稿、聊天记录、现场目击，真实线索优先筛选。',
    stat: '今日 19 条',
    cover:
      'https://readdy.ai/api/search-image?query=stylized%20abstract%20sealed%20envelope%20and%20microphone%20on%20warm%20amber%20crimson%20background%2C%20editorial%20collage%20texture%2C%20cinematic%20lighting%2C%20high%20detail%2C%20no%20people&width=720&height=520&seq=hl-cat-04&orientation=landscape',
    items: [
      { title: '剧组探班目击记录公开，细节被逐条比对', meta: '15 分钟前' },
      { title: '网友补交停车场角度画面', meta: '52 分钟前' },
      { title: '一组聊天记录进入核实流程', meta: '2 小时前' },
    ],
  },
];